<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"></h5>
                    <button type="button" data-dismiss="modal" class="modal-close" aria-label="Cancel" @click="closeModal()">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <h1 class="mx-3">{{ negotiationUpdateMessage }}</h1>
                    <i class="fas fa-exclamation-circle my-3 mb-5 fa-5x text-danger"></i>
                </div>
                <div class="modal-footer justify-content-center">
                    <button class="btn btn-tertiary mr-2" id="cancelButton" @click="closeModal()" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    computed: {
        ...mapState('negotiation', ['negotiationUpdateMessage'])
    },
    methods: {
        ...mapActions('negotiation', ['showNegotiationUnavailableWindow']),
        closeModal: function(){
            $('.modal-backdrop').hide(); // hide any remaining modal backdrops
            this.showNegotiationUnavailableWindow(false);
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>